import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    document.querySelector('.add-all-facilities').addEventListener('click', this.addAllFacilities.bind(this));
  }

  addAllFacilities(event) {
    const options = $('.add-all-facilities').data('options');

    $('.group-selection').val(options).trigger('change')
  }
}
